import React from 'react'
import {
  CAvatar,
  CBadge,
  CDropdown,
  CDropdownDivider,
  CDropdownHeader,
  CDropdownItem,
  CDropdownMenu,
  CDropdownToggle,
} from '@coreui/react'
import {
  cilBell,
  cilCreditCard,
  cilCommentSquare,
  cilEnvelopeOpen,
  cilFile,
  cilLockLocked,
  cilSettings,
  cilTask,
  cilUser,
} from '@coreui/icons'
import CIcon from '@coreui/icons-react'
import { useNavigate } from 'react-router-dom'
import { useAuth } from "../../../../hooks/useAuth"; // utiliser le hook moderne pour naviguer

const BackAppHeaderDropdown = () => {

  const { getUser,logout } = useAuth();
  const handleLogout = () => {
    logout();
  };

  // Récupération des infos utilisateur
  const user = getUser();
  const username = localStorage.getItem('username') || 'Utilisateur';
  const avatar = localStorage.getItem('avatar') || '/assets/images/user/default-avatar.png';

  return (
      <CDropdown variant="nav-item">
        <CDropdownToggle placement="bottom-end" className="py-0 pe-0" caret={false}>
          <CAvatar src={avatar} size="md" />
        </CDropdownToggle>

        <CDropdownMenu className="pt-0" placement="bottom-end">
          <CDropdownHeader className="bg-body-secondary fw-semibold mb-2">{username}</CDropdownHeader>

          <CDropdownItem href="dashboard/posts">
            <CIcon icon={cilBell} className="me-2" />
            Notifications
            <CBadge color="info" className="ms-2">
              {user.notifications?.length || 0} {/* si tu stockes notifications dans l’objet user */}
            </CBadge>
          </CDropdownItem>

          <CDropdownItem href="dashboard/messages">
            <CIcon icon={cilEnvelopeOpen} className="me-2" />
            Messages
            <CBadge color="success" className="ms-2">
              {user.messages?.length || 0}
            </CBadge>
          </CDropdownItem>

          <CDropdownItem href="dashboard/tasks">
            <CIcon icon={cilTask} className="me-2" />
            Tâches
            <CBadge color="danger" className="ms-2">
              {user.tasks?.length || 0}
            </CBadge>
          </CDropdownItem>

          <CDropdownHeader className="bg-body-secondary fw-semibold my-2">Settings</CDropdownHeader>

          <CDropdownItem href="/dashboard/profil">
            <CIcon icon={cilUser} className="me-2" />
            Profil
          </CDropdownItem>

          <CDropdownItem href="/dashboard/parametres">
            <CIcon icon={cilSettings} className="me-2" />
            Paramètres
          </CDropdownItem>

          <CDropdownDivider />

          <CDropdownItem onClick={handleLogout}>
            <CIcon icon={cilLockLocked} className="me-2" />
            Déconnexion
          </CDropdownItem>
        </CDropdownMenu>
      </CDropdown>
  )
}

export default BackAppHeaderDropdown
